import {CommonService} from '../../services/common.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {LoadingService} from '../../services/loading.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import {ViewEncapsulation} from '@angular/core';

@Component({
  // encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-details-form.component.scss', '../../table/table.component.scss'],
  templateUrl: './edit-details-form.component.html'
})
export class EditDetailsFormComponent implements OnInit {
  public previousTechnicianId: number;
  public serialNumber: string;
  public scheduledDate: Date;
  public minDate: Date;
  public selection: SelectionModel<any>;
  public title: string;
  public displayedColumns: string [];
  public dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private matDialogRef: MatDialogRef<EditDetailsFormComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = this.data.type === 0 ? 'Ενημέρωση σειριακού αριθμού' : this.data.type === 1 ? 'Ενημέρωση προγραμματισμένης ημερομηνίας' : 'Ενημέρωση ανάθεσης σε τεχνικό';
    this.dataSource = new MatTableDataSource<any>();
    if (this.data.type === 0) {
      this.serialNumber = this.data.row.serial_number;
    }
    if (this.data.type === 1) {
      this.scheduledDate = this.data.expected_date ? new Date(this.data.expected_date) : this.addDays(new Date(), 1);
    }
    if (this.data.type === 2) {
      this.previousTechnicianId = this.data.previousTechnicianId ? this.data.previousTechnicianId : 0;


      // this.dataSource.data = this.data.technicians;
      this.dataSource = new MatTableDataSource<any>(this.data.technicians);
      this.scheduledDate = this.addDays(new Date(), 1);
      this.displayedColumns = ['select', 'id', 'description', 'role_description', 'internal_description'];
      this.selection = new SelectionModel<any>(true, []);
      if (this.previousTechnicianId && this.previousTechnicianId !== 0) {
        this.data.technicians.forEach((row) => {
          if (row.id === this.previousTechnicianId) {
            this.selection.select(row);
          }
        });
      }
    }
  }

  public ngOnInit(): void {
    this.minDate = new Date();
    this.matDialogRef.updateSize(this.data.type !== 2 ? '450px' : '850px');
    this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
    this.dataSource.sort = this.sort;
  }

  closeDialog() {
    this.matDialogRef.close();
  }

  private addDays(date: Date, numberOfDays: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + numberOfDays);
    return result;
  }

  isTechnicianInvalid() {
    return this.selection.selected.length === 0 || !this.scheduledDate;
  }

  public applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async updateSerialNumber() {
    const model = {
      repair_details_id: this.data.row.id,
      change_type: 'serial_number',
      initial_value: this.data.row.serial_number,
      changed_value: this.serialNumber
    };
    let error;
    try {
      // this.loadingService.show();
      await this.commonService.updateObject(`repair/web/${this.data.repairOrderId}`, model);
      this.data.row.serial_number = this.serialNumber;
    } catch (e) {
      error = e;
    } finally {
      this.loadingService.hide();
      if (error) {
        this.matDialogRef.close({success: false, err: error});
      } else {
        this.matDialogRef.close({success: true, result: this.data.row});
      }
    }
  }

  updateDate() {
    this.matDialogRef.close({success: true, expected_date: this.scheduledDate});
  }

  updateTechnician() {
    this.matDialogRef.close({success: true, selectedTechnician: this.selection.selected[0], expected_date: this.scheduledDate});
  }

  isSerialNumberEmpty(): boolean {
    return !this.serialNumber;
  }

  isDateEmpty(): boolean {
    return !this.scheduledDate;
  }

  selectRow($event: any, row: any) {
    const prevRow = this.selection.selected.length > 0 ? this.selection.selected[0] : null;
    if (prevRow) {
      this.selection.clear();
      this.selection.toggle(row);
    }
    if (prevRow === row || !prevRow) {
      return this.selection.toggle(row);
    } else {
      return null;
    }
  }
}
